import React from 'react';
import { Badge, Tooltip } from '@mantine/core';
import { getSurveyBadgeLabel } from '../../constants/surveyTypes';

type SurveySourceBadgeProps = {
    isFromPriceSurvey?: boolean | null;
    priceSurveyType?: string | null;
    priceSurveyLabel?: string | null;
    size?: 'xs' | 'sm' | 'md';
};

export function SurveySourceBadge({
    isFromPriceSurvey,
    priceSurveyType,
    priceSurveyLabel,
    size = 'xs',
}: SurveySourceBadgeProps) {
    const badgeLabel = getSurveyBadgeLabel(priceSurveyType, priceSurveyLabel);

    if (!isFromPriceSurvey || !badgeLabel) {
        return null;
    }

    return (
        <Tooltip
            label={`From ${badgeLabel} price survey`}
            openDelay={100}
            classNames={{
                tooltip: 'bg-[#4D5E80] text-white rounded-md text-xs px-2 py-1',
            }}
        >
            <Badge color="blue" size={size} variant="light">
                {badgeLabel}
            </Badge>
        </Tooltip>
    );
}

export function renderSurveySourceBadges(request: {
    isFromPriceSurvey?: boolean | null;
    priceSurveyType?: string | null;
    priceSurveyLabel?: string | null;
}) {
    const { isFromPriceSurvey, priceSurveyType, priceSurveyLabel } = request;

    if (!isFromPriceSurvey) {
        return null;
    }

    return (
        <div className="flex flex-wrap items-center justify-center gap-1">
            <SurveySourceBadge
                isFromPriceSurvey
                priceSurveyType={priceSurveyType}
                priceSurveyLabel={priceSurveyLabel}
            />
        </div>
    );
}
